module.exports = __webpack_public_path__ + "img/superwebShopLogo.68cbb1b.svg";